/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistantConversationsGet200ResponseConversationsInner
 */
export interface AssistantConversationsGet200ResponseConversationsInner {
    /**
     * 
     * @type {string}
     * @memberof AssistantConversationsGet200ResponseConversationsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantConversationsGet200ResponseConversationsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantConversationsGet200ResponseConversationsInner
     */
    lastMessageTime: string;
}

/**
 * Check if a given object implements the AssistantConversationsGet200ResponseConversationsInner interface.
 */
export function instanceOfAssistantConversationsGet200ResponseConversationsInner(value: object): value is AssistantConversationsGet200ResponseConversationsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('lastMessageTime' in value) || value['lastMessageTime'] === undefined) return false;
    return true;
}

export function AssistantConversationsGet200ResponseConversationsInnerFromJSON(json: any): AssistantConversationsGet200ResponseConversationsInner {
    return AssistantConversationsGet200ResponseConversationsInnerFromJSONTyped(json, false);
}

export function AssistantConversationsGet200ResponseConversationsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantConversationsGet200ResponseConversationsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'lastMessageTime': json['lastMessageTime'],
    };
}

export function AssistantConversationsGet200ResponseConversationsInnerToJSON(json: any): AssistantConversationsGet200ResponseConversationsInner {
    return AssistantConversationsGet200ResponseConversationsInnerToJSONTyped(json, false);
}

export function AssistantConversationsGet200ResponseConversationsInnerToJSONTyped(value?: AssistantConversationsGet200ResponseConversationsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'lastMessageTime': value['lastMessageTime'],
    };
}

